import { useId } from 'react';
import { Icon } from '../icon/icon.spark';
import { Text } from '../text/text.spark';
import { Tooltip } from '../tooltip/tooltip.spark';
import type { RadioSetProps } from './types';

export function RadioSet<T extends string = string>(props: RadioSetProps<T>) {
  const baseId = useId();

  return (
    <fieldset
      className="flex flex-col gap-2 text-sm text-spark-text-primary"
      disabled={props.disabled}
      name={props.name ?? baseId}
    >
      {props.label && (
        <legend className="mb-2 flex items-center gap-1">
          {props.label}
          {props.tooltip && (
            <Tooltip content={props.tooltip}>
              <Icon name="infoCircle" />
            </Tooltip>
          )}
        </legend>
      )}

      {props.options.map((option) => {
        const id = `${baseId}-${option.value}`;

        return (
          <div
            className="grid grid-cols-[auto_1fr] items-center gap-x-2"
            key={option.key ?? option.value}
          >
            <input
              type="radio"
              id={id}
              name={props.name ?? baseId}
              value={option.value}
              disabled={option.disabled}
              checked={option.value === props.value}
              onChange={() => props.onChange?.(option.value)}
              className="peer form-radio col-start-1 row-start-1 text-spark-purple focus:ring-spark-purple disabled:cursor-not-allowed disabled:border-gray-300 disabled:checked:border-gray-300 disabled:checked:bg-gray-100"
            />
            <label
              htmlFor={id}
              className="col-start-2 row-start-1 peer-disabled:text-spark-text-secondary"
            >
              {option.label}
            </label>
            {option.description && (
              <div className="col-start-2 row-start-2">
                <Text variant="secondary">{option.description}</Text>
              </div>
            )}
          </div>
        );
      })}
    </fieldset>
  );
}
